<template>
  <div class="app_config_cla">
    <el-card class="box-card" v-if="appConfigList.length !== 0">
      <template v-for="item in appConfigList">
        <div :key="item.id">
          <span class="config-title-cla">{{ item.name }}</span>
          <div class="app_config_des">
            {{ item.remark }}
          </div>
          <div class="app_associated_cla">
            <div style="text-align: center">
              <span>{{ $t('developer.assApplication') }}</span>
              <span class="app_ass_num"
                ><span
                  :class="
                    countAppConfig.opens === 0 ||
                    countAppConfig.opens === undefined
                      ? 'color__error'
                      : 'color__primary'
                  "
                  >{{ countAppConfig.opens ? countAppConfig.opens : 0 }}</span
                >
                / {{ countAppConfig.alls ? countAppConfig.alls : 0 }}</span
              >
            </div>
          </div>
          <div style="text-align: right">
            <el-button type="primary" @click="toConfigUrl">
              {{ $t('developer.config') }}
            </el-button>
          </div>
        </div>
      </template>
    </el-card>
    <zkNoData v-else></zkNoData>
  </div>
</template>

<script>
import { getByType } from '@/cdpBase/services/dictionary.js'
import { countAppInfoConfig } from '@/services/appManagerApi.js'
export default {
  data() {
    return {
      appConfigList: [],
      countAppConfig: {}
    }
  },
  methods: {
    getAppConfigList() {
      getByType('appConfig').then(data => {
        this.appConfigList = data.results.results
      })
    },

    toConfigUrl() {
      this.$router.push({
        path: '/appManager/appFunSetting'
      })
    },

    getCountAppInfoConfig() {
      countAppInfoConfig()
        .then(data => {
          if (data.code === '00000000') {
            this.countAppConfig = data.payload.result
            this.getAppConfigList()
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => {
          this.loading = false
          this.errorMessage()
        })
    }
  },
  mounted() {
    this.getCountAppInfoConfig()
  }
}
</script>

<style scoped lang="less">
@import '~@/styles/var.less';
.color__error {
  color: @ststusFailed;
}
.color__primary {
  color: @statusSuccess;
}
.app_config_cla {
  width: 100%;
  height: 100%;
  background: #fff;

  /deep/ .box-card {
    width: 400px;
    border: 1px solid black;
    border-left-width: 4px;
    border-left-color: @themeColor;
    margin: 10px;
  }
  .config-title-cla {
    font-weight: 700;
    font-size: 20px;
  }
  .app_config_des {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    font-size: 14px;
    color: @fontColor3;
  }
  .app_associated_cla {
    display: flex;
    justify-content: space-around;
    margin-top: 10px;
    .app_ass_num {
      font-size: 14px;
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/developer/appConfigSetting.vue